// Thrown by content-view builders when the requested entity is missing from the
// store (deleted, wrong organization, or a stale link). This is expected user
// behaviour rather than a bug, so content-view-factory degrades to an empty view
// and reports it as a single grouped warning instead of a per-uuid error.
export class EntityNotFoundError extends Error {
  override name = 'EntityNotFoundError';
  constructor(
    public entityType: string,
    public entityUuid: string,
  ) {
    super(`${entityType} ${entityUuid} not found in store`);
  }
}

// Same narrowing contract as assertIsDefined, but throws a typed EntityNotFoundError
// so content-view-factory can degrade to an empty view + single grouped warning
// instead of a per-uuid error. Use for primary entity-by-uuid store lookups.
export function assertEntityFound<T>(
  value: T,
  entityType: string,
  entityUuid: string,
): asserts value is NonNullable<T> {
  if (value === undefined || value === null) {
    throw new EntityNotFoundError(entityType, entityUuid);
  }
}
